import { EventTypeEnum } from '../enums';

export interface DevicePositionsWithDevicesRequest {
    organizationId?: string;
    from: string;
    to: string;
    deviceIds?: number[];
}

export interface DeviceEventsWithDevicesRequest extends DevicePositionsWithDevicesRequest {
    eventType: EventTypeEnum;
}
